module.exports = __webpack_public_path__ + "static/media/KMH_5228.eebb972d.jpg";